module.exports = __webpack_public_path__ + "media/luxury-2026/formal-dining-d440dd96.jpg";